import { CloudCheck, CloudSlash, WifiHigh } from "@phosphor-icons/react";

const TABS = [["pos", "POS"], ["sales", "Sales"], ["customers", "Customers"], ["setup", "Setup"]];

function Pill({ tone, icon: Icon, children, testId }) {
    return (
        <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-widest ${tone}`}>
            <Icon size={13} weight="bold" />{children}
        </span>
    );
}

export default function PosHeader({ event, online, prepared, tab, setTab, pending }) {
    return (
        <div className="space-y-3">
            <div className="flex flex-wrap items-end justify-between gap-3">
                <div className="min-w-0">
                    <h1 className="font-serif text-3xl text-ink leading-none" data-testid="pos-title">Hoshizora POS</h1>
                    <p className="mt-1 text-sm text-neutral-500 truncate" data-testid="pos-event-name">
                        {event ? `${event.name}${event.status === "CLOSED" ? " · Closed" : ""}` : "No active event"}
                    </p>
                </div>
                <div className="flex flex-wrap items-center gap-1.5">
                    {online
                        ? <Pill tone="bg-sage-dark text-white" icon={WifiHigh} testId="pos-status-online">Online</Pill>
                        : <Pill tone="bg-red-700 text-white" icon={CloudSlash} testId="pos-status-offline">Offline</Pill>}
                    {prepared && <Pill tone="bg-champagne/30 text-ink" icon={CloudCheck} testId="pos-status-ready">Offline Ready</Pill>}
                    {pending > 0 && <span className="text-[10px] uppercase tracking-widest text-amber-700" data-testid="pos-pending-count">{pending} waiting to sync</span>}
                </div>
            </div>
            <nav className="flex gap-1 border-b border-mist overflow-x-auto" data-testid="pos-subnav">
                {TABS.map(([k, l]) => (
                    <button key={k} onClick={() => setTab(k)} data-testid={`pos-tab-${k}`}
                        className={`px-4 py-2 text-xs uppercase tracking-widest whitespace-nowrap transition-colors ${tab === k ? "border-b-2 border-sage-dark text-ink font-semibold" : "text-neutral-500 hover:text-ink"}`}>
                        {l}
                    </button>
                ))}
            </nav>
        </div>
    );
}
